import React, { useEffect } from 'react';
import { Controller, Control } from 'react-hook-form';
import Select from '../select/select';

const primaryRegions = [
  {
    value: 'VN-63',
    label: 'Hà Nội',
    priority: 1,
  },
  {
    value: 'VN-62',
    label: 'Hồ Chí Minh',
    priority: 2,
  },
  {
    value: 'VN-06',
    label: 'Bắc Ninh',
    priority: 3,
  },
  {
    value: 'VN-60',
    label: 'Hải Phòng',
    priority: 4,
  },
  {
    value: 'VN-35',
    label: 'Nam Định',
    priority: 5,
  },
];

export interface VuonConcertRegion {
  id: number;
  value: string;
  label: string;
  code?: string;
  priority?: number;
}

// Hook function type để inject từ bên ngoài
export type UseRegionsHook = () => {
  data?: Array<{
    id: number;
    code: string;
    name: string;
  }>;
};

export const VuonConcertRegionSelectControl = ({
  control,
  name,
  label,
  require,
  onChange,
  defaultValue,
  value,
  placeholder,
  disabled,
  useRegionsHook, // Inject hook từ bên ngoài
}: {
  defaultValue?: any;
  onChange: (region: VuonConcertRegion) => void;
  control: Control<any>;
  name: string;
  label?: string;
  require?: boolean;
  value?: any;
  placeholder?: string;
  disabled?: boolean;
  useRegionsHook: UseRegionsHook; // Required dependency
}) => {
  const { data } = useRegionsHook(); // Sử dụng hook được inject
  const [regionValue, setRegionValue] = React.useState<any>();

  const regions = data?.map((item) => {
    return {
      value: item?.code || '',
      label: item?.name || '',
      priority: primaryRegions.find((region) => region.value === item?.code)?.priority || 1000,
      id: item?.id,
      code: item?.code,
    };
  });

  // locale sort
  regions?.sort((a, b) => a.label.localeCompare(b.label));
  // Sort by priority asc
  regions?.sort((a, b) => a.priority - b.priority);

  useEffect(() => {
    if (value?.value) {
      setRegionValue(value);
    } else {
      setRegionValue(null);
    }
  }, [value]);

  return (
    <div className={'w-full'}>
      <Controller
        name={name}
        control={control}
        defaultValue={defaultValue}
        render={({ field }) => (
          <Select
            {...field}
            onSelectionChange={(e) => {
              field.onChange(e);
              onChange(e);
              setRegionValue(e);
            }}
            label={label}
            placeHolder={placeholder ?? 'Tỉnh/thành'}
            options={regions ?? []}
            value={regionValue}
            classNameLabel="font-montserrat text-white text-[12px] md:text-[18px] font-bold"
            className="font-montserrat"
            isDisable={disabled}
          />
        )}
      />
    </div>
  );
};
